var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title fw-bold"},[_vm._v("ME23 Collection")]),_c('ItemList',{staticClass:"card-item",attrs:{"products":_vm.menCollection,"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }